export class Mensagem {
  id!: string;
  titulo!: string;
  texto!: string;
}
